import { IStringifyOptions } from 'qs';
export { cache } from 'swr';
import { Options } from 'ky';

export * from './ky';
export * from './swr';

/**
 * Flat query string object usable with URLSearch
 */
export interface QueryParams {
  [key: string]: string | number | boolean | string[] | string[] | number[] | boolean[];
}

export interface DeepQueryParams {
  [key: string]: string | number | boolean | string[] | number[] | boolean[] | DeepQueryParams;
}

export interface KyOptions extends Omit<Options, 'searchParams' | 'prefixUrl'> {
  searchParams?: string | QueryParams | Array<Array<string | number | boolean>> | URLSearchParams | DeepQueryParams;
  prefixUrl?: string;
}

/**
 * Options for SWR fetcher instantiators
 * TODO: split this up so that we manage custom, swr and ky options individually
 */
export interface FetcherOptions extends KyOptions {
  /**
   * Use GIK redis cache
   */
  useCache?: boolean;
  withAllPages?: boolean;
  deepQueryParams?: DeepQueryParams;
  qsStringifyOptions?: IStringifyOptions;
  testRetry?: boolean;
}

export function getBasicAuthString(username: string, password: string): string {
  return `Basic ${Buffer.from(`${username}:${password}`).toString('base64')}`;
}

export async function optimisticUpdate(newData: unknown, mutate: Function, apiFunction: Function) {
  mutate(newData, false);
  await apiFunction();
  mutate();
}
